import { Injectable } from '@angular/core';
import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { ConfigService } from './config.service';
import { BaseConfig } from './models/config.model';

@Injectable()
export class OauthModuleConfigService {
  private config?: BaseConfig;

  constructor(configService: ConfigService) {
    configService.getConfig().subscribe({
      next: (config) => (this.config = config),
    });
  }

  getOauthModuleConfig(): OAuthModuleConfig {
    return {
      resourceServer: {
        sendAccessToken: true,
        customUrlValidation: (url: string) => this.checkUrl(url),
      },
    };
  }

  private checkUrl(url: string): boolean {
    if (this.config && url.startsWith(this.config.apiUrl)) {
      return true;
    }
    return false;
  }
}
